/**
 * Reusable site footer — used by legal pages and the marketing site.
 * Wires every link in the IA. All hrefs are real routes; no dead links.
 */
import React from "react";
import { Link } from "react-router-dom";

const LOGO_MARK = "/ashra-logo-mark.png";

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-zinc-200 bg-zinc-50/50" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-14">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-10 mb-10">
          <FooterColumn title="Product">
            <FooterLink to="/#features">Features</FooterLink>
            <FooterLink to="/#pricing">Pricing</FooterLink>
            <FooterLink to="/signup">Start Free Trial</FooterLink>
            <FooterLink to="/login">Login</FooterLink>
          </FooterColumn>
          <FooterColumn title="Resources">
            <FooterLink to="/blog">Growth Hub</FooterLink>
            <FooterLink to="/blog">Blog</FooterLink>
            <FooterLink to="/#faq">FAQ</FooterLink>
          </FooterColumn>
          <FooterColumn title="Company">
            <FooterLink to="/#about">About</FooterLink>
            <FooterLink to="mailto:hello@ashraai.com" external>Contact</FooterLink>
          </FooterColumn>
          <FooterColumn title="Legal">
            <FooterLink to="/terms">Terms of Service</FooterLink>
            <FooterLink to="/privacy">Privacy Policy</FooterLink>
            <FooterLink to="/refund-policy">Refund Policy</FooterLink>
          </FooterColumn>
        </div>
        <div className="border-t border-zinc-200 pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="flex items-center gap-2.5">
            <img src={LOGO_MARK} alt="Ashra AI" className="h-7 w-auto" />
            <span className="text-sm text-zinc-600">© {year} Ashra AI · The AI Revenue Operating System.</span>
          </div>
          <p className="text-xs text-zinc-500">
            Made for creators, coaches, consultants &amp; agencies.
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({ title, children }) {
  return (
    <div>
      <h4 className="text-[11px] uppercase tracking-wider text-zinc-400 font-semibold mb-3">{title}</h4>
      <ul className="space-y-2">{children}</ul>
    </div>
  );
}

function FooterLink({ to, children, external }) {
  if (external) {
    return (
      <li>
        <a href={to} className="text-sm text-zinc-700 hover:text-violet-700 transition">{children}</a>
      </li>
    );
  }
  return (
    <li>
      <Link to={to} className="text-sm text-zinc-700 hover:text-violet-700 transition">{children}</Link>
    </li>
  );
}
